import MultiRangeSlider from "@kopapro/components/commons/multiRangeSlider/multiRangeSlider";

export default MultiRangeSlider;